export default "__VITE_ASSET__Dbh9M50X__"